export interface OrderDetailFinanceAccountingView {
    dateTime: string,
    description: string,
    subDescription?: string,
    numberOfUnits: number,
    percent: number,
    amount: number,
    debitAmount: number,
    creditAmount: number,
    balanceAmount: number,
    icon?: string,
    iconClass?: string,
    hierarchyId: string,
    parentHierarchyId: string,
    referenceOrderId?: string,
    type?: FinanceAccountionType
    priceRuleCode?: string,
    individualIconClass?: string
}

export enum FinanceAccountionType {
    Product,
    Price,
    Payment,
    PaymentProduct,
    Ledger,
    Refund,
    Exchange,
    Balance,
    Individual,
    Voucher,
    CancelledPayment
}